import { setComponentMapOverrides } from '@jutro/legacy/uiconfig';
import 'gw-capability-quoteandbind-PremierPR-react';
import 'gw-capability-policychange-common-react';
import 'premier-capability-policychange-common-react';
import PRPolicyChangesPage from './pages/PRPolicyChanges/PRPolicyChangesPage';

setComponentMapOverrides(
    {
        PremierPRPolicyChangesPage: { component: 'PremierPRPolicyChangesPage' }
    },
    {
        PremierPRPolicyChangesPage: PRPolicyChangesPage
    }
);

export { default as PremierPRPolicyChangeWizard } from './PremierPRPolicyChangeWizard';
